module.exports = __webpack_public_path__ + "static/media/DAVSC.c3f927f9.pdf";